import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  paragraph: {
    paddingBottom: theme.spacing(2),
  },
}));
